import React, { useRef, useEffect } from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import InfoImg from '../../../../assets/images/icon-info.svg';

const InfoMessage = ({ showModal, closeModal, getLangTranslation, message }) => {
    const modalRef = useRef();

    useEffect(() => {
        if (showModal) {
            const modal = new Modal(modalRef.current, {
                backdrop: 'static',
                keyboard: false,
            });
            modal.show();
        }
    }, [showModal]);
    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <i className='icon-info-one text-blue-800 display-4 faded-border d-inline-block rounded-circle mb-6' />
                        <h5 className='fw-bold mb-2 text-center'>{message[0]}</h5>
                        {
                            message[1] && (
                                <span>{message[1]}</span>
                            )
                        }
                        <button className="btn btn-primary w-100 mt-9" type="button" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}>
                            <span className="btn-upper-case">{getLangTranslation('DEFAULT_SETTING_GOT_IT', 'Got it')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InfoMessage